import { ThemeOptions } from '@mui/material/styles';

/** Azul Escuro — vermelho, branco e azul da bandeira americana */
export const USA_AZUL_BANDEIRA = '#0A3161';
export const USA_VERMELHO_BANDEIRA = '#B22234';

export const usaPaletteOptions: ThemeOptions['palette'] = {
  mode: 'light',
  primary: {
    main: USA_AZUL_BANDEIRA,
    light: '#3D5A80',
    dark: '#051C38',
    contrastText: '#ffffff',
  },
  secondary: {
    main: USA_VERMELHO_BANDEIRA,
    light: '#D4455C',
    dark: '#8B1A28',
    contrastText: '#ffffff',
  },
  error: {
    main: '#d32f2f',
    light: '#ef5350',
    dark: '#c62828',
  },
  warning: {
    main: '#f59e0b',
    light: '#fbbf24',
    dark: '#d97706',
  },
  info: {
    main: USA_AZUL_BANDEIRA,
    light: '#3D5A80',
    dark: '#051C38',
  },
  success: {
    main: '#2e7d32',
    light: '#4caf50',
    dark: '#1b5e20',
  },
  background: {
    default: '#f4f6fa',
    paper: '#ffffff',
  },
  text: {
    primary: '#1a2332',
    secondary: '#4a5568',
    disabled: '#8b95a5',
  },
  divider: 'rgba(10, 49, 97, 0.12)',
  action: {
    active: '#4a5568',
    hover: 'rgba(10, 49, 97, 0.08)',
    selected: 'rgba(178, 34, 52, 0.14)',
    disabled: 'rgba(0, 0, 0, 0.26)',
    disabledBackground: 'rgba(0, 0, 0, 0.12)',
  },
  grey: {
    50: '#f8fafc',
    100: '#eef2f7',
    200: '#dde4ee',
    300: '#c5d0de',
    400: '#8b95a5',
    500: '#6b7788',
    600: '#4a5568',
    700: '#334155',
    800: '#1a2332',
    900: '#0f172a',
    A100: '#f5f5f5',
    A200: '#eeeeee',
    A400: '#bdbdbd',
    A700: '#616161',
  },
  gradient: {
    primary: 'linear-gradient(135deg, #051C38 0%, #0A3161 50%, #3D5A80 100%)',
    secondary: 'linear-gradient(135deg, #8B1A28 0%, #B22234 50%, #D4455C 100%)',
  },
};

export const usaComponentOverrides: ThemeOptions['components'] = {
  MuiCssBaseline: {
    styleOverrides: {
      body: {
        scrollbarColor: '#c5d0de transparent',
      },
    },
  },
  MuiDrawer: {
    styleOverrides: {
      paper: {
        backgroundColor: '#ffffff',
        backgroundImage: 'none',
        borderRight: '1px solid #dde4ee',
      },
    },
  },
  MuiAppBar: {
    styleOverrides: {
      root: {
        backgroundImage: 'none',
        boxShadow: '0 2px 4px rgba(10, 49, 97, 0.14)',
      },
    },
  },
  MuiCard: {
    styleOverrides: {
      root: {
        border: '1px solid rgba(10, 49, 97, 0.1)',
        boxShadow: '0 4px 20px rgba(10, 49, 97, 0.08)',
      },
    },
  },
  MuiPaper: {
    styleOverrides: {
      root: {
        backgroundImage: 'none',
      },
    },
  },
  MuiTableCell: {
    styleOverrides: {
      root: {
        borderColor: 'rgba(10, 49, 97, 0.1)',
      },
    },
  },
  MuiOutlinedInput: {
    styleOverrides: {
      root: {
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: 'rgba(10, 49, 97, 0.22)',
        },
        '&:hover .MuiOutlinedInput-notchedOutline': {
          borderColor: 'rgba(10, 49, 97, 0.45)',
        },
      },
    },
  },
  MuiButton: {
    styleOverrides: {
      containedPrimary: {
        boxShadow: '0 4px 14px rgba(10, 49, 97, 0.35)',
      },
      containedSecondary: {
        boxShadow: '0 4px 14px rgba(178, 34, 52, 0.3)',
      },
    },
  },
  MuiChip: {
    styleOverrides: {
      colorPrimary: {
        backgroundColor: 'rgba(10, 49, 97, 0.12)',
        color: USA_AZUL_BANDEIRA,
      },
      colorSecondary: {
        backgroundColor: 'rgba(178, 34, 52, 0.12)',
        color: USA_VERMELHO_BANDEIRA,
      },
    },
  },
};
